import React from "react";
import ActionMenu from "widgets/ActionMenu";
import { buildList } from "widgets/ActionMenu/utils";
import ContentFeedViewDetails from "./ContentFeedViewDetails";
import ContentFeedRefresh from "./ContentFeedRefresh";
import ContentFeedUpdatesHistory from "./ContentFeedUpdatesHistory";

export const contentFeedRefreshAction = {
	name: 'refresh',
	component: ({ contentFeedId, contentFeedName, creativeCount, libraryId }) => (
		<ContentFeedRefresh
			contentFeedId={contentFeedId}
			contentFeedName={contentFeedName}
			creativeCount={creativeCount}
			libraryId={libraryId}
		/>
	),
};

export const viewContentFeedAction = {
	name: 'view',
	component: ({
		contentFeedName,
		format,
		url,
		itemKey,
		eligibleItems,
		totalItems,
		lastSync,
		mapping,
		contentFeedId,
		libraryId,
	}) => (
		<ContentFeedViewDetails
			contentFeedName={contentFeedName}
			format={format}
			url={url}
			itemKey={itemKey}
			eligibleItems={eligibleItems}
			totalItems={totalItems}
			lastSync={lastSync}
			mapping={mapping}
			contentFeedId={contentFeedId}
			libraryId={libraryId}
		/>
	),
};

export const updatesHistoryAction = {
	name: 'updatesHistory',
	component: ({ contentFeedId, contentFeedName, libraryId }) => (
		<ContentFeedUpdatesHistory
			contentFeedId={contentFeedId}
			contentFeedName={contentFeedName}
			libraryId={libraryId}
		/>
	),
};

function ContentFeedActions({ dependentValues }) {
	const {
		contentFeedId,
		contentFeedName,
		creativeCount,
		format,
		url,
		itemKey,
		eligibleItems,
		totalItems,
		lastSync,
		mapping,
		libraryId,
	} = dependentValues;

	const actions = [
		contentFeedRefreshAction,
		viewContentFeedAction,
	];

	const extraActions = [
		[updatesHistoryAction],
	];

	const actionContext = {
		contentFeedId,
		contentFeedName,
		creativeCount,
		format,
		url,
		itemKey,
		eligibleItems,
		totalItems,
		lastSync,
		mapping,
		libraryId,
	};

	const [menuItems] = buildList([actions], actionContext);

	return (
		<div className="grid-actions flex-center">
			{menuItems}
			<ActionMenu
				actionLists={extraActions}
				actionContext={actionContext}
			/>
		</div>
	);
}

ContentFeedActions.displayName = "ContentFeedActions";

export const ContentFeedActionsCell = {
	key: "actions",
	name: "Actions",
	width: 100,
	resizable: false,
	sortable: false,
	formatter: ContentFeedActions,
	getRowMetaData(data) {
		return {
			contentFeedId: data.id,
			contentFeedName: data.name,
			creativeCount: data.creativeCount || 0,
			format: data.format,
			url: data.url,
			itemKey: data.itemKey,
			eligibleItems: data.eligibleItems,
			totalItems: data.totalItems,
			lastSync: data.lastSync,
			mapping: data.mapping,
			libraryId: data.libraryId,
		};
	},
};

